export type VideoFormat = '360p' | '480p' | '720p' | '1080p';
export const convertVideoFormat = (
    format: 'QUALITY_360p' | 'QUALITY_480p' | 'QUALITY_720p',
): VideoFormat => {
    switch (format) {
        case 'QUALITY_360p':
            return '360p';
        case 'QUALITY_480p':
            return '480p';
        case 'QUALITY_720p':
            return '720p';
    }
};
export type VideoProgressStatus =
    | 'NOT_STARTED'
    | 'QUEUED'
    | 'IN_PROGRESS'
    | 'COMPLETE'
    | 'FAILED';
